import { MCBNS010InitDisplayRequest } from 'types/MCBNS010/MCBNS010InitDisplayRequest'
import { MCBNS010SeminarIdRequest } from 'types/MCBNS010/MCBNS010SeminarIdRequest'
import request from 'utils/request'

export const getAutoReservationRemindListApi = (requestdata: MCBNS010InitDisplayRequest) =>
  request({
    url: '/MCBNS010/init',
    method: 'post',
    data: requestdata
  })

export const editAutoReservationRemindApi = (requestdata: MCBNS010SeminarIdRequest) =>
  request({
    url: '/MCBNS010/edit',
    method: 'post',
    data: requestdata
  })